export default __webpack_public_path__ + "static/media/Affinity_Rev_02.abcde2b1.svg";